import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { AppProviders } from '@/app/providers/AppProviders';
import { EVENT } from '@/shared/config/event.config';
import '@/app/styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

// O nome do evento entra na aba aqui, e não no `index.html`: HTML estático não lê os
// ajustes do painel, e escrevê-lo lá criaria uma terceira cópia do mesmo nome.
document.title = `${document.title} · ${EVENT.fullTitle}`;

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
